import React, {useContext, useState} from "react";

import styles from "./UIModalReport.module.scss";
import {useTranslation} from "react-i18next";
//@ts-ignore
import _ from "lodash";

import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {checkEmpty} from "src/service/util.service";
import {AppContext} from "src/pages/context/App.context";
import useFetch, {CachePolicies} from "use-http";

interface UIModalReportProps {
    refId: string
    profile: any
    onClose: () => void
}

const UIModalReport:React.FunctionComponent<UIModalReportProps> = (props) => {
    const {t, i18n} = useTranslation();
    const [loading, setLoading]: any = useState(false);
    const [messageNoti, setMessageNoti]: any = useState("");
    const [issue, setIssue]: any = useState(null);
    const [reason, setReason]: any = useState(null);
    const appcontext: any = useContext(AppContext);

    const antIcon = (
        <LoadingOutlined style={{fontSize: 24, color: "#FFFFFF"}} spin/>
    );

    const apiReport = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/create`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const fnDone = async () => {
        let data = {
            refID: props.profile?.id,
            userRefID: props.profile?.id,
            reportReason: reason,
            reportTopic: issue,
            reportType: "user",
        };
        const res = await apiReport.post("", data);
        props.onClose();
    };

    return (
        <div style={{width: "100%"}}>
            <div className={styles.reportHeader}>{t("Report an issue")}</div>
            {checkEmpty(issue) && (
                <div className={styles.boxSelectIssue}>
                    <div
                        className={styles.issueItem}
                        onClick={() => {
                            setIssue(t("Pretending to Be Someone"));
                        }}
                    >
                        {t("Pretending to Be Someone")}
                    </div>
                    <div
                        className={styles.issueItem}
                        onClick={() => {
                            setIssue("Fake Account");
                        }}
                    >
                        {t("Fake Account")}
                    </div>
                    <div
                        className={styles.issueItem}
                        onClick={() => {
                            setIssue("Fake Name");
                        }}
                    >
                        {t("Fake Name")}
                    </div>
                    <div
                        className={styles.issueItem}
                        onClick={() => {
                            setIssue("Something Else");
                        }}
                    >
                        {t("Something Else")}
                    </div>
                </div>
            )}
            {!checkEmpty(issue) && (
                <div
                    style={{
                        paddingTop: "20px",
                    }}
                >
                    <div style={{display: "flex"}}>
                        <div className={styles.textTitleIssue}>{t("Issue") + " :"}</div>
                        <div>&nbsp;{t(issue)}</div>
                    </div>
                    <div style={{display: "flex"}}>
                        <div className={styles.textTitleIssue}>{t("Reason") + " : "}</div>
                    </div>
                    <div>
            <textarea
                className={styles.reasontext}
                rows={4}
                cols={12}
                onChange={(e) => {
                    setReason(e.target.value)
                }}
            ></textarea>
                    </div>
                    <div>
                        <button
                            className={styles.bottonBtnOk}
                            style={{fontSize: "1.2rem", marginTop: "39px"}}
                        >
                            <div onClick={fnDone}>
                                {apiReport.loading ? <Spin indicator={antIcon}/> : t("Submit")}
                            </div>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UIModalReport;
